import PropTypes from "prop-types";
import Select from "react-select";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { addEditdonators } from "../../Redux/Slices/donatorSlice";
import { getUserList, getVillageList } from "../../Redux/Slices/committeeSlice";
import { getOneUserAnalytics } from "../../Redux/Slices/userAnalyticsSlice";
import { useParams } from "react-router-dom";

const AddEditDonator = ({ isOpen, onClose, rowData }) => {
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [villages, setVillages] = useState([]);
  const [memberSearch, setMemberSearch] = useState("");
  const [villageSearch, setVillageSearch] = useState("");
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [isVillageLoading, setIsVillageLoading] = useState(false);


  const menuPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const initialValues = {
    donatorId: "",
    fundId: "",
    user: "",
    village: "",
    donatortype: "",
  };
  const dispatch = useDispatch();

  const [formikInitialValue, setFormikInitialValue] = useState(initialValues);

  const validationSchema = Yup.object().shape({
    // english_name: Yup.string().required("Fund name in English is required"),
    // gujarati_name: Yup.string().required("Fund name in Gujarati is required"),
  });

  const getUser = async (search = "") => {
    setIsUserLoading(true);
    try {
      const payload = {
        search: search,
      };
      const response = await dispatch(getUserList(payload)).unwrap();
      if (response.IsSuccess) {
        setUsers(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Users");
    } finally {
      setIsUserLoading(false);
    }
  };
  const getVillage = async (search = "") => {
    setIsVillageLoading(true);
    try {
      const payload = { search };
      const response = await dispatch(getVillageList(payload)).unwrap();
      if (response.IsSuccess) {
        setVillages(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Villages");
    } finally {
      setIsVillageLoading(false);
    }
  };

  useEffect(() => {
    getVillage(villageSearch);
  }, [villageSearch]);

  useEffect(() => {
    getUser(memberSearch);
  }, [memberSearch]);

  useEffect(() => {
    if (rowData) {
      setFormikInitialValue({
        donatorId: rowData?._id || "",
        fundId: rowData?.fund?._id || "",
        user: rowData?.user?._id || "",
        village: rowData?.village?._id || "",
        donatortype: rowData?.donatortype || "",
      });
    } else {
      setFormikInitialValue(initialValues);
    }
  }, [rowData]);

  const handleSubmit = async (values) => {
    const payload = {
      donatorId: values?.donatorId || "",
      fundId: id || "",
      user: values?.user || "",
      village: values?.village || "",
      donatortype: values?.donatortype || "",
    };
    const response = await dispatch(addEditdonators(payload)).unwrap();
    if (response.IsSuccess) {
      toast.success(response.Message);
      //   navigate("/occupations");
    }
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black opacity-50 backdrop-blur-lg"></div>

      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white rounded-3xl shadow-xl max-w-4xl w-full p-3 md:p-7">
          <div className="flex items-center justify-between p-4">
            <h3 className="text-18 lg:text-26 font-bold text-gray-900">
              Add Donator
            </h3>
            <button onClick={onClose} className="hover:text-text_1">
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <Formik
            initialValues={formikInitialValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, touched, isSubmitting, values, setFieldValue }) => (
              <Form className="p-4">
                <div className="md:flex gap-4 mb-3 md:mb-5">
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2 mb-1">
                      Select Member
                    </label>
                    <Select
                      id="user"
                      name="user"
                      isLoading={isUserLoading}
                      filterOption={() => true}
                      inputValue={memberSearch}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") setMemberSearch(inputValue);
                      }}
                      onBlur={() => setMemberSearch("")}
                      options={users.map((item) => ({
                        value: item?._id,
                        label:
                          item?.surname +
                          " " +
                          item?.name +
                          " " +
                          item?.fathername +
                          ` (${item?.village?.gujarati_name || ""})`,
                      }))}
                      value={
                        users
                          .filter((u) => u._id === values.user)
                          .map((item) => ({
                            value: item?._id,
                            label:
                              item?.surname +
                              " " +
                              item?.name +
                              " " +
                              item?.fathername +
                              ` (${item?.village?.gujarati_name || ""})`,
                          }))[0] || null
                      }
                      onChange={async (selectedOption) => {
                        setMemberSearch("");
                        const userId = selectedOption
                          ? selectedOption.value
                          : "";
                        setFieldValue("user", userId);

                        if (userId) {
                          try {
                            const payload = { userId };
                            const res = await dispatch(
                              getOneUserAnalytics(payload),
                            ).unwrap();
                            if (res.IsSuccess && res.Data) {
                              setFieldValue(
                                "village",
                                res.Data.village?._id || "",
                              );
                            }
                          } catch (error) {
                            toast.error("Failed to fetch user details");
                          }
                        }
                      }}
                      placeholder="Select Member"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={menuPortalStyles}
                      isClearable
                    />
                  </div>
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2 mb-1">
                      Select Village
                    </label>
                    <Select
                      id="village"
                      name="village"
                      isLoading={isVillageLoading}
                      filterOption={() => true}
                      inputValue={villageSearch}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") setVillageSearch(inputValue);
                      }}
                      onBlur={() => setVillageSearch("")}
                      options={villages.map((item) => ({
                        value: item?._id,
                        label: item?.gujarati_name,
                      }))}
                      value={
                        villages
                          .filter((v) => v._id === values.village)
                          .map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))[0] || null
                      }
                      onChange={(selectedOption) => {
                        setVillageSearch("");
                        setFieldValue(
                          "village",
                          selectedOption ? selectedOption.value : "",
                        );
                      }}
                      placeholder="Select Village"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={menuPortalStyles}
                      isClearable
                    />
                  </div>
                </div>
                <div className="md:flex gap-4 mb-3 md:mb-5">
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2">
                      Donator Type
                    </label>
                    <Field
                      as="select"
                      id="donatortype"
                      name="donatortype"
                      className="w-full px-3 py-3.5 bg-[#EEEEEE] rounded-md"
                    >
                      <option value=""> Select Donator Type </option>
                      <option value="gold">Gold</option>
                      <option value="silver">Silver</option>
                      <option value="platinum">Platinum</option>
                    </Field>
                  </div>
                </div>
                <div className="flex items-center justify-center p-4 space-x-3 xl:space-x-5">
                  <button
                    type="button"
                    onClick={onClose}
                    className="btn_secondary"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn py-2.5 md:py-3.5 px-8 md:px-12"
                  >
                    {isSubmitting ? "Submitting..." : "Save"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
AddEditDonator.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object,
  getDistrictListFun: PropTypes.func,
  children: PropTypes.any,
};

export default AddEditDonator;
